module.exports = [
	{
		"id": "30341DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30341DC1/640/30341DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and M Size Boiler",
		"textblock_1st_text": "30341DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and M size boiler for instant kettle-hot water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30341DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30341001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30341001/640/30341001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and M Size Boiler",
		"textblock_1st_text": "30341001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and M size boiler for instant kettle-hot water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30341001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30340DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30340DC1/640/30340DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and L Size Boiler",
		"textblock_1st_text": "30340DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and L size boiler for instant kettle-hot water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30340DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30340001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30340001/640/30340001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and L Size Boiler",
		"textblock_1st_text": "30340001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and L size boiler for instant kettle-hot water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30340001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30329001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30329001/640/30329001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30329001",
		"textblock_2nd_text": "GROHE RED Mono kitchen tap (L-spout) with filter set and M size boiler for instant kettle-hot water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30329001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30328DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30328DC1/640/30328DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and L Size Boiler",
		"textblock_1st_text": "30328DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and L size boiler for instant kettle-hot water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30328DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30328001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30328001/640/30328001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and L Size Boiler",
		"textblock_1st_text": "30328001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and L size boiler for instant kettle-hot water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30328001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30060001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30060001/640/30060001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Pillar tap and M size boiler",
		"textblock_1st_text": "30060001",
		"textblock_2nd_text": "GROHE RED Mono kitchen tap (C-spout) with filter set and M size boiler for instant kettle-hot water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30060001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30058DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30058DC1/640/30058DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and M Size Boiler",
		"textblock_1st_text": "30058DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and M size boiler for instant kettle-hot water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30058DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30058001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30058001/640/30058001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Tap and M Size Boiler",
		"textblock_1st_text": "30058001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and M size boiler for instant kettle-hot water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/30058001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set with Rainshower Cosmopolitan 310mm metal head shower, Sena hand shower and Rapido T thermostatic mixer for concealed installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set with Rainshower Cosmopolitan 310mm metal head shower, Sena hand shower and Rapido T thermostatic mixer for concealed installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with thermostat amd side showers",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat and body jets",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with bath thermostat for wall mounting",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat and bath spout",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with diverter",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower 400 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria 210 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "GROHE Rainshower 310 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "GROHE Rainshower 310 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26363000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26363000/640/26363000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "26363000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26363000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High L-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High L-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High C-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High C-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High U-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High U-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono starter kit: pillar tap for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High C-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starter kit",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono starter kit: pillar tap for filtered, chilled and sparkling water. Includes cooler unit, filter and CO2 carbonisation bottle. High C-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Thermostatic shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Perfect shower set with Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"textblock_2nd_text": "GROHE Grohtherm 2000 Perfect Shower Set, including thermostatic tap",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Thermostatic shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M shower thermostat with GROHE Euphoria 110 Massage shower set, 600 mm shower rail",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Thermostatic shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34321002",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Cosmopolitan M shower thermostat with GROHE Euphoria 110 Massage shower set, 900 mm shower rail",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower 210",
		"textblock_1st_text": "34408000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set with Rainshower Cosmopolitan 210mm metal head shower, Euphoria 110mm hand shower and Rapido T thermostatic mixer for concealed installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect shower set with Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan comfort shower set, concealed thermostat included",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Perfect shower set with Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "GROHE Grohtherm Cube Perfect shower set with Rainshower Allure 230mm head shower, Euphoria Cube hand shower and Rapido T thermostatic mixer for concealed installation.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Shower system with bath thermostat for wall mounting",
		"textblock_1st_text": "26223001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 Shower System with thermostat for bathtubs, 210mm head shower and 100mm two-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Shower system with single lever for wall mounting",
		"textblock_1st_text": "26224001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 Shower System with single lever mixer, 210mm head shower and 100mm two-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27296002",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with thermostat, SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with single lever for wall mounting",
		"textblock_1st_text": "27473001",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with single lever mixer, water-saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with bath thermostat for wall mounting",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "GROHE Euphoria 260 Bath/Shower System with thermostat for bathtubs, water saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta System 210",
		"subheadline": "Flex shower system with diverter for wall mounting",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Shower system with thermoststic mixer for wall mounting",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "GROHE Euphoria XXL Shower System with thermostat; chrome and German engineered with 310mm metal head shower and 110mm three-spray hand shower.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with thermoststic mixer for wall mounting",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL 230 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27421002",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with diverter. Water saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with thermostat, water saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "with thermostat for wall mounting",
		"textblock_1st_text": "27922001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 Shower System with thermostat, 210mm head shower and 100mm two-spray hand shower in chrome. Easy to fit and clean. German engineering.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.co.uk/en_gb/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.co.uk/en_gb/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_en_gb.json
// module id = 299
// module chunks = 0